import { useSelector } from 'react-redux'
import { useHistory, useParams } from 'react-router'

export default function usePracticeUtil() {
  const { selectedLesson, courseLeftMenu } = useSelector(
    state => state.mainReducer
  )
  const history = useHistory()
  const params = useParams()

  function moveToNextLesson() {
    const lessonData = selectedLesson
    if (lessonData?.nextLesson) {
      const nextLesson = lessonData.nextLesson
      const url = `/introduction/course/${params.courseId}/chapter/${params.chapterId}/unit/${params.unitId}/lesson/${nextLesson.id}`
      history.push(url)
    } else {
      // checking for next chapter
      const nextChapterIndex = courseLeftMenu.chapters.findIndex(
        item => item.chapterId === lessonData.chapterId
      )
      if (nextChapterIndex !== -1) {
        let nextChapter = courseLeftMenu.chapters[nextChapterIndex + 1];
        const nextLesson = nextChapter?.lessons?.length && nextChapter?.lessons[0] //moving the first item of next chapter

        if (nextChapter && nextLesson) {
          const url = `/introduction/course/${params.courseId}/chapter/${params.chapterId}/unit/${params.unitId}/lesson/${nextLesson.id}`
          history.push(url)

        } else {
          history.push('/language')
        }
      } else {
        history.push('/language')
      }
    }
  }

  return {
    moveToNextLesson,
  }
}
